import { Button, Input, Label, SimpleSelect } from '@kalos/ui';
import { useId } from 'react';

/**
 * The search field with Filter inside it. Typing searches as you go; Filter opens the other
 * filters, which apply on Apply. The placeholder names what the box searches. `ListSearchPhone`
 * in components/ListPhone places it with the chips and the sheet.
 */
export const MobileSearchBar = ({
  value,
  onChange,
  placeholder,
  activeFilterCount,
  onOpenFilters,
  filterLabel = 'Filter',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  activeFilterCount: number;
  /** Leave out when the list has nothing to filter or sort by beyond the box. */
  onOpenFilters?: () => void;
  /** "Sort" when the sheet holds only the sort order. */
  filterLabel?: string;
}) => (
  <div className="relative">
    <Input
      type="search"
      autoComplete="off"
      placeholder={placeholder}
      aria-label={placeholder}
      className={onOpenFilters ? 'bg-card pr-24' : 'bg-card'}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {onOpenFilters && (
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="absolute right-1 top-1/2 -translate-y-1/2 text-sm"
        onClick={onOpenFilters}
      >
        {activeFilterCount ? `${filterLabel} (${activeFilterCount})` : filterLabel}
      </Button>
    )}
  </div>
);

/** One choice of sort order, in words: "Last Name, A to Z". */
export type SortOption = { value: string; label: string };

/** The sort order, as the last field in a filter sheet. Sorting isn't a filter, so no chip. */
export const SortField = ({
  value,
  options,
  onChange,
}: {
  value: string;
  options: SortOption[];
  onChange: (value: string) => void;
}) => {
  const id = useId();
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>Sort by</Label>
      <SimpleSelect id={id} values={options} selectedValue={value} onChange={onChange} />
    </div>
  );
};
